import React, { Component, Fragment } from "react";

import { connect } from "react-redux";
import "../../1688-taobao-orders/invoice-by-order.css";
import KidoLogo from "../../../assets/images/brand/kido-logo.png";
import { BRAND } from "../../../constants/brand";

import { withRouter } from "react-router-dom";
import { getAllCustomerLoansRedux } from "../../../actions";
export class OnlyInvoieToPrint extends Component {
  state = {
    userObj: null,
    orderObj: null,
  };
  componentDidMount = async () => {
    this.props.getAllCustomerLoansRedux();
  };

  render() {
    const { allCustomers } = this.props;
    let dueCustomers = allCustomers.filter((customer) => customer.amount > 0);
    let date = new Date();

    let totalCustomerDue = 0;
    dueCustomers.map((customer) => {
      totalCustomerDue += parseInt(customer.amount);
    });

    // Same KIDO invoice design as the order invoice (invoice-by-order.css).
    return (
      <div className="zp-inv-page">
        <div className="zp-inv-card">
          <div className="zp-inv-accent" />

          <header className="zp-inv-header">
            <div>
              <div className="zp-inv-brand">
                <img src={KidoLogo} alt="KIDO" />
              </div>
              <div className="zp-inv-company-info">
                {/* TODO: KIDO's address once the client provides it */}
                <div>{BRAND.phone}</div>
                <div>{BRAND.email}</div>
              </div>
            </div>
            <div className="zp-inv-title-block">
              <div className="zp-inv-title">Customer due</div>
              <div className="zp-inv-number">
                As of {date.toLocaleDateString("en-GB")}
              </div>
            </div>
          </header>

          <div className="zp-inv-meta">
            <div>
              <div className="zp-inv-meta-label">Statement</div>
              <div className="zp-inv-detail-row">
                <span className="k">Print date</span>
                <span className="v">{date.toLocaleDateString("en-GB")}</span>
              </div>
              <div className="zp-inv-detail-row">
                <span className="k">Currency</span>
                <span className="v">BDT</span>
              </div>
              <div className="zp-inv-detail-row">
                <span className="k">Customers with due</span>
                <span className="v">{dueCustomers.length}</span>
              </div>
            </div>
            <div>
              <div className="zp-inv-meta-label">Summary</div>
              <div className="zp-inv-summary-row zp-inv-summary-row--due">
                <span className="k">Total due</span>
                <span className="v">৳{totalCustomerDue}</span>
              </div>
            </div>
          </div>

          <div className="zp-inv-section">
            <table className="zp-inv-payments-table zp-inv-statement-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>As of date</th>
                  <th>Customer name</th>
                  <th className="is-num">Total due</th>
                </tr>
              </thead>
              <tbody>
                {dueCustomers.map((customer, index) => (
                  <tr key={customer.id || index}>
                    <td>{index + 1}</td>
                    <td>{date.toLocaleDateString("en-GB")}</td>
                    <td>{String(customer.customer || "").replace(/^undefined-/, "")}</td>
                    <td className="is-num">{parseInt(customer.amount)}Tk</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {dueCustomers.length === 0 && (
              <p className="zp-inv-note">No customer has a due right now.</p>
            )}
          </div>

          <div className="zp-inv-footer">
            <div className="zp-inv-note">
              Amounts are what each customer owes as of the print date.
            </div>
            <div className="zp-inv-thanks">KIDO</div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    allCustomers: state.loans.allCustomers,
  };
};
export default withRouter(
  connect(mapStateToProps, { getAllCustomerLoansRedux })(OnlyInvoieToPrint)
);
